export const AdjustmentGroups = {
    CO: 'Contractural Obligations	',
    OA: 'Other Adjustments	',
    PI: 'Payor Initiated Reductions	',
    PR: 'Patient Responsibility	',
};
